import { createContext } from 'react'

const adoptionFairContext = createContext()

export default adoptionFairContext
